import apiHelper from '../helper/ApiHelper';

const HeadService = {
  async getCMS(slug) {
    try {
      return await apiHelper(`/cms/${slug}`);
    } catch (error) {
      console.error('Error fetching heads:', error);
      throw error;
    }
  },
};

export default HeadService;